module.exports = __webpack_public_path__ + "img/Icon_inventario_padres_hover.e18cdf7f.svg";